module.exports = __webpack_public_path__ + "img/image_7.bc1dd593.png";